/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BackupPolicySecurityConfig } from '../models/BackupPolicySecurityConfig';

export class BackupPoliciesSecurityConfig {
  /**
  * The security scan configuration for the backup policies specified
  */
  'policiesConfig': Array<BackupPolicySecurityConfig>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "policiesConfig",
      "baseName": "policiesConfig",
      "type": "Array<BackupPolicySecurityConfig>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BackupPoliciesSecurityConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

